

























































import { defineComponent, ref, reactive, computed } from "@vue/composition-api";

import store from "@/store";
import BaseInputField from "@/shared/components/base/BaseInputField/BaseInputField.vue";
import LoadingButton from "@/shared/components/LoadingButton";
import { ValidationObserver } from "vee-validate";

export default defineComponent({
  name: "MeterReadingLoginForm",
  props: {
    maloIDParam: {
      type: String,
      default: "",
    },
    meterReadingIDParam: {
      type: String,
      default: "",
    },
  },
  components: {
    BaseInputField,
    LoadingButton,
    ValidationObserver,
  },
  setup(props: any) {
    // Get nescessary functions and values from the store
    const formData = reactive({
      maloID: props.maloIDParam,
      meterReadingID: props.meterReadingIDParam,
    });
    const submitted = ref(false);
    const isSubmitting = ref(false);
    const errors = ref([]);

    const {
      getUserHasValidLoginCombination,
      setMaloID: updateStoreMaloID,
      setMeterReadingID: updateStoreMeterReadingID,
    } = store.dispatch;

    const { hasValidLoginData, maloID, meterReadingID } = store.getters;

    const prefilledDataIsInvalid = computed(
      () => !!maloID && !!meterReadingID && !hasValidLoginData
    );

    // Initialization logic with async setters and functions
    const onSubmit = async () => {
      submitted.value = true;
      isSubmitting.value = true;
      await updateStoreMaloID(formData.maloID);
      await updateStoreMeterReadingID(formData.meterReadingID);
      // @ts-ignore
      await getUserHasValidLoginCombination();
      submitted.value = true;
      isSubmitting.value = false;
    };

    return {
      formData,
      hasValidLoginData,
      submitted,
      isSubmitting,
      onSubmit,
      errors,
      prefilledDataIsInvalid,
    };
  },
});
